import { arrayToObject } from 'lib/arrayUtils'
import { reducerSwitch, createReducer } from 'lib/reducerUtils'
import { saveCruiseCabinOptionsState } from 'storage/cruise'

import {
  FETCH_CRUISE_LINES,
  FETCH_CRUISE_PROMO_BANNERS, FETCH_CRUISES_LIST_RECOMMENDATION,
  FETCH_CRUISE_OFFER,
  FETCH_CRUISE_SEARCH_FACETS,
  FETCH_CRUISE_SEARCH_COUNT,
  FETCH_CRUISE_SAILINGS,
  FETCH_CRUISE_SHIP_DECK,
  FETCH_CRUISE_CABIN_RATES,
  FETCH_CRUISE_CABIN_HOLD,
  FETCH_CRUISE_CABIN_RELEASE,
  FETCH_CRUISE_CABIN_PRICING,
  FETCH_CRUISE_CABIN_DETAILS,
  FETCH_CRUISE_CABIN_RATE_DETAILS,
  FETCH_CRUISE_CABIN_AVAILABILITY,
  FETCH_CRUISE_BOOKING_BY_ID,
  FETCH_CRUISE_DEPARTURE_BY_ID,
  FETCH_CRUISE_LOWEST_PRICE_BY_MONTH,
  RESET_SESSION_ID,
} from 'actions/apiActionConstants'

import {
  API_CALL_REQUEST,
  API_CALL_FAILURE,
  API_CALL_SUCCESS,
  SAVE_CABIN_OPTION,
  RESTORE_CABIN_OPTION,
  RESET_REVELEX_CALLS,
  RESET_CABIN_AVAILABILITY,
  CRUISE_IN_FLOW_CHECKOUT_STEP,
  CRUISE_SET_SEARCH_FACETS,
  CRUISE_SET_CRUISE_LINES,
} from 'actions/actionConstants'

const initialState: App.CruiseState = {
  endOfPagination: false,
  fetchingCruises: true,
  cruiseLines: [],
  fetchingCruiseLines: false,
  cruiseIdListRecommendation: [],
  mapLegend: [],
  cruiseSailingList: {},
  fetchingCruiseSailingList: {},
  cruiseOffers: {},
  cruiseOffersLoading: {},
  cruiseLowestPricesByMonth: {},
  cruiseOffersErrors: {},
  deckSelections: {},
  cabinAvailability: [],
  cabinAvailabilityLoading: false,
  cabinAvailabilityError: false,
  cabinAvailabilityErrorToRender: null,
  cabinRelease: false,
  cabinReleaseLoading: true,
  cabinReleaseError: false,
  cabinHold: null,
  cabinHoldNumber: null,
  cabinHoldLoading: false,
  cabinHoldError: null,
  cabinPricing: null,
  cabinPricingLoading: false,
  cabinPricingError: false,
  cabinPricingErrorToRender: null,
  cruiseCabinPreferences: null,
  dirtyPreferences: false,
  isCabinOptionsRestored: false,
  cabinDetails: null,
  cabinDetailsLoading: false,
  cabinDetailsError: false,
  cabinRates: null,
  departureId: null,
  cabinRatesError: null,
  cabinRatesErrorMessage: null,
  cabinRatesErrorToRender: null,
  revelexSessionId: null,
  cabinRatesLoading: null,
  cabinRateDetails: null,
  cabinRateDetailsError: null,
  cabinRateDetailsLoading: null,
  cruiseBookingInfo: {},
  cruiseBookingInfoError: {},
  cruiseBookingInfoLoading: {},
  cruiseDeparture: {},
  cruiseDepartureError: {},
  cruiseDepartureLoading: {},
  travelers: null,
  bookingId: null,
  personTitles: null,
  infantMinAge: null,
  cruiseFacets: {},
  searchCount: 0,
  fetchingSearchCount: false,
  cruisePromoBanners: [],
  fetchingCruisePromoBanners: false,
  inFlowCheckoutStep: null,
}

const apiRequests = reducerSwitch<App.CruiseState>({
  [FETCH_CRUISE_LINES]: () => ({
    fetchingCruiseLines: true,
  }),
  [FETCH_CRUISE_SEARCH_FACETS]: (state, action) => ({
    cruiseFacets: {
      ...state.cruiseFacets,
      [action.key]: {
        fetching: true,
        facets: [],
      },
    },
  }),
  [FETCH_CRUISE_SEARCH_COUNT]: () => ({
    searchCount: 0,
    fetchingSearchCount: true,
  }),
  [FETCH_CRUISE_PROMO_BANNERS]: () => ({
    fetchingCruisePromoBanners: true,
  }),
  [FETCH_CRUISE_LOWEST_PRICE_BY_MONTH]: (state, action) => ({
    cruiseLowestPricesByMonth: {
      ...state.cruiseLowestPricesByMonth,
      [action.key]: {
        fetching: true,
        lowestPrices: [],
      },
    },
  }),
  [FETCH_CRUISE_SAILINGS]: (state, action) => ({
    fetchingCruiseSailingList: {
      ...state.fetchingCruiseSailingList,
      ...arrayToObject(
        action.ids as Array<string>,
        (id) => id,
        () => true,
      ),
    },
  }),
  [FETCH_CRUISE_OFFER]: (state, action) => ({
    ...state,
    cruiseOffersLoading: {
      ...state.cruiseOffersLoading,
      [action.offerId]: true,
    },
  }),
  [FETCH_CRUISE_BOOKING_BY_ID]: (state, action) => ({
    ...state,
    cruiseBookingInfoError: {
      ...state.cruiseBookingInfoError,
      [action.id]: false,
    },
    cruiseBookingInfoLoading: {
      ...state.cruiseBookingInfoLoading,
      [action.id]: true,
    },
  }),
  [FETCH_CRUISE_DEPARTURE_BY_ID]: (state, action) => ({
    ...state,
    cruiseDepartureError: {
      ...state.cruiseDepartureError,
      [action.departureId]: false,
    },
    cruiseDepartureLoading: {
      ...state.cruiseDepartureLoading,
      [action.departureId]: true,
    },
  }),
  [FETCH_CRUISE_SHIP_DECK]: (state) => ({
    ...state,
    // TODO loading
  }),
  [FETCH_CRUISE_CABIN_RATES]: (state, action) => ({
    ...state,
    cabinRatesError: false,
    cabinRatesLoading: true,
    travelers: action.travelers,
    cabinRatesErrorToRender: null,
    departureId: action.departureId,
  }),
  [FETCH_CRUISE_CABIN_RATE_DETAILS]: (state, action) => ({
    ...state,
    cabinRateDetailsError: {
      ...state.cabinRateDetailsError,
      [action.componentId]: false,
    },
    cabinRateDetailsLoading: {
      ...state.cabinRateDetailsLoading,
      [action.componentId]: true,
    },
  }),
  [FETCH_CRUISE_CABIN_AVAILABILITY]: (state) => ({
    ...state,
    cabinAvailabilityLoading: true,
    cabinAvailabilityError: false,
    cabinAvailabilityErrorToRender: null,
  }),
  [FETCH_CRUISE_CABIN_HOLD]: (state) => ({
    ...state,
    cabinHoldLoading: true,
    cabinHoldError: null,
  }),
  [FETCH_CRUISE_CABIN_RELEASE]: (state) => ({
    ...state,
    cabinRelease: false,
    cabinReleaseLoading: true,
    cabinReleaseError: false,
    cabinHold: null,
    cabinHoldError: null,
    cabinHoldLoading: false,
    cabinPricing: null,
    cabinPricingError: false,
    cabinPricingLoading: false,
  }),
  [FETCH_CRUISE_CABIN_PRICING]: (state) => ({
    ...state,
    cabinPricingLoading: true,
    cabinPricingError: false,
    cabinPricingErrorToRender: null,
  }),
  [FETCH_CRUISE_CABIN_DETAILS]: (state) => ({
    ...state,
    cabinDetailsLoading: true,
    cabinDetailsError: false,
  }),
})

const apiSuccesses = reducerSwitch<App.CruiseState>({
  [FETCH_CRUISES_LIST_RECOMMENDATION]: (state, action) => ({
    cruiseIdListRecommendation: action.data,
  }),
  [FETCH_CRUISE_LINES]: (state, action) => ({
    cruiseLines: action.data,
    fetchingCruiseLines: false,
  }),
  [FETCH_CRUISE_SEARCH_FACETS]: (state, action) => ({
    cruiseFacets: {
      ...state.cruiseFacets,
      [action.key]: {
        fetching: false,
        facets: action.data,
      },
    },
  }),
  [FETCH_CRUISE_SEARCH_COUNT]: (state, action) => ({
    searchCount: action.data,
    fetchingSearchCount: false,
  }),
  [FETCH_CRUISE_PROMO_BANNERS]: (state, action) => ({
    cruisePromoBanners: action.data,
    fetchingCruisePromoBanners: false,
  }),
  [FETCH_CRUISE_LOWEST_PRICE_BY_MONTH]: (state, action) => ({
    cruiseLowestPricesByMonth: {
      ...state.cruiseLowestPricesByMonth,
      [action.key]: {
        fetching: false,
        lowestPrices: action.data,
      },
    },
  }),
  [FETCH_CRUISE_SAILINGS]: (state, action) => ({
    cruiseSailingList: {
      ...state.cruiseSailingList,
      ...arrayToObject(
        action.data as Array<App.CruiseOffer>,
        (sailing) => sailing.id,
      ),
    },
    fetchingCruiseSailingList: {
      ...state.fetchingCruiseSailingList,
      ...arrayToObject(
        action.ids as Array<string>,
        (id) => id,
        () => false,
      ),
    },
  }),
  [FETCH_CRUISE_OFFER]: (state, action) => ({
    ...state,
    cruiseOffersLoading: {
      ...state.cruiseOffersLoading,
      [action.offerId]: false,
    },
    cruiseOffers: {
      ...state.cruiseOffers,
      [action.offerId]: action.data,
    },
  }),
  [FETCH_CRUISE_BOOKING_BY_ID]: (state, action) => ({
    ...state,
    cruiseBookingInfoError: {
      ...state.cruiseBookingInfoError,
      [action.id]: false,
    },
    cruiseBookingInfoLoading: {
      ...state.cruiseBookingInfoLoading,
      [action.id]: false,
    },
    cruiseBookingInfo: {
      ...state.cruiseBookingInfo,
      [action.id]: action.data,
    },
  }),
  [FETCH_CRUISE_DEPARTURE_BY_ID]: (state, action) => ({
    ...state,
    cruiseDepartureError: {
      ...state.cruiseDepartureError,
      [action.departureId]: false,
    },
    cruiseDepartureLoading: {
      ...state.cruiseDepartureLoading,
      [action.departureId]: false,
    },
    cruiseDeparture: {
      ...state.cruiseDeparture,
      [action.departureId]: action.data,
    },
  }),
  [FETCH_CRUISE_SHIP_DECK]: (state, action) => ({
    ...state,
    deckSelections: {
      ...state.deckSelections,
      [action.deckId]: action.data,
    },
  }),
  [FETCH_CRUISE_CABIN_RATES]: (state, action) => ({
    ...state,
    cabinRatesError: false,
    cabinRatesLoading: false,
    cabinRatesErrorToRender: null,
    cabinRates: action.data.cabins,
    bookingId: action.data.bookingId,
    departureId: action.data.departureId,
    revelexSessionId: action.data.sessionId,
    personTitles: action.data.personTitles,
    infantMinAge: action.data.infantMinAge,
  }),
  [FETCH_CRUISE_CABIN_RATE_DETAILS]: (state, action) => ({
    ...state,
    cabinRateDetailsError: {
      ...state.cabinRateDetailsError,
      [action.componentId]: false,
    },
    cabinRateDetailsLoading: {
      ...state.cabinRateDetailsLoading,
      [action.componentId]: false,
    },
    cabinRateDetails: {
      ...state.cabinRateDetails,
      [action.componentId]: action.data,
    },
  }),
  [FETCH_CRUISE_CABIN_AVAILABILITY]: (state, action) => {
    return {
      ...state,
      cabinAvailability: action.data.cabins,
      mapLegend: action.data.mapLegend,
      ...(action.data.cabinHold && {
        cabinHold: action.data.cabinHold,
        cabinHoldNumber: action.data.cabins[0].cabinNumber,
      }),
      cabinAvailabilityError: false,
      cabinAvailabilityLoading: false,
      cabinAvailabilityErrorToRender: null,
    }
  },
  [FETCH_CRUISE_CABIN_HOLD]: (state, action) => ({
    ...state,
    cabinHold: action.data,
    cabinHoldLoading: false,
    cabinHoldError: null,
  }),
  [FETCH_CRUISE_CABIN_RELEASE]: (state, action) => ({
    ...state,
    cabinRelease: action.data.success,
    cabinReleaseLoading: false,
    cabinReleaseError: false,
  }),
  [FETCH_CRUISE_CABIN_PRICING]: (state, action) => ({
    ...state,
    cabinPricing: action.data,
    cabinPricingLoading: false,
    cabinPricingError: false,
    cabinPricingErrorToRender: null,
    dirtyPreferences: false,
  }),
  [FETCH_CRUISE_CABIN_DETAILS]: (state, action) => ({
    ...state,
    cabinDetails: action.data,
    cabinDetailsLoading: false,
    cabinDetailsError: false,
  }),
})

const apiFailures = reducerSwitch<App.CruiseState>({
  [FETCH_CRUISE_SEARCH_FACETS]: (state, action) => ({
    cruiseFacets: {
      ...state.cruiseFacets,
      [action.key]: {
        fetching: false,
        facets: [],
        error: action.error,
      },
    },
  }),
  [FETCH_CRUISE_SEARCH_COUNT]: () => ({
    searchCount: 0,
    fetchingSearchCount: true,
  }),
  [FETCH_CRUISE_PROMO_BANNERS]: () => ({
    fetchingCruisePromoBanners: false,
  }),
  [FETCH_CRUISE_LOWEST_PRICE_BY_MONTH]: (state, action) => ({
    cruiseLowestPricesByMonth: {
      ...state.cruiseLowestPricesByMonth,
      [action.key]: {
        fetching: false,
        lowestPrices: [],
        error: action.error,
      },
    },
  }),
  [FETCH_CRUISE_SAILINGS]: (state, action) => ({
    fetchingCruiseSailingList: {
      ...state.fetchingCruiseSailingList,
      ...arrayToObject(
        action.ids as Array<string>,
        (id) => id,
        () => false,
      ),
    },
  }),
  [FETCH_CRUISE_OFFER]: (state, action) => ({
    ...state,
    cruiseOffersLoading: {
      ...state.cruiseOffersLoading,
      [action.offerId]: false,
    },
    cruiseOffersErrors: {
      ...state.cruiseOffersErrors,
      [action.offerId]: action.error,
    },
  }),
  [FETCH_CRUISE_BOOKING_BY_ID]: (state, action) => ({
    ...state,
    cruiseBookingInfoError: {
      ...state.cruiseBookingInfoError,
      [action.id]: true,
    },
    cruiseBookingInfoLoading: {
      ...state.cruiseBookingInfoLoading,
      [action.id]: false,
    },
  }),
  [FETCH_CRUISE_DEPARTURE_BY_ID]: (state, action) => ({
    ...state,
    cruiseDepartureError: {
      ...state.cruiseDepartureError,
      [action.departureId]: true,
    },
    cruiseDepartureLoading: {
      ...state.cruiseDepartureLoading,
      [action.departureId]: false,
    },
  }),
  [FETCH_CRUISE_SHIP_DECK]: (state) => ({
    ...state,
    deckSelections: null,
    // TODO error
  }),
  [FETCH_CRUISE_CABIN_RATES]: (state, action) => ({
    ...state,
    cabinRates: null,
    cabinRatesError: true,
    cabinRatesLoading: false,
    cabinRatesErrorMessage: action.error?.message,
    cabinRatesErrorToRender: action.error?.errorToRender,
  }),
  [FETCH_CRUISE_CABIN_RATE_DETAILS]: (state, action) => ({
    ...state,
    cabinRateDetailsError: {
      ...state.cabinRateDetailsError,
      [action.componentId]: true,
    },
    cabinRateDetailsLoading: {
      ...state.cabinRateDetailsLoading,
      [action.componentId]: false,
    },
    cabinRateDetails: {
      ...state.cabinRateDetails,
      [action.componentId]: null,
    },
  }),
  [FETCH_CRUISE_CABIN_AVAILABILITY]: (state, action) => ({
    ...state,
    cabinAvailability: null,
    cabinAvailabilityError: true,
    cabinAvailabilityLoading: false,
    cabinAvailabilityErrorToRender: action.error?.errorToRender,
  }),
  [FETCH_CRUISE_CABIN_HOLD]: (state, action) => ({
    ...state,
    cabinHold: null,
    cabinHoldLoading: false,
    cabinHoldError: action.error?.errorToRender,
  }),
  [FETCH_CRUISE_CABIN_RELEASE]: (state) => ({
    ...state,
    cabinRelease: false,
    cabinReleaseLoading: false,
    cabinReleaseError: true,
  }),
  [FETCH_CRUISE_CABIN_PRICING]: (state, action) => {
    return ({
      ...state,
      cabinPricing: null,
      cabinPricingLoading: false,
      cabinPricingError: true,
      cabinPricingErrorToRender: action.error?.errorToRender,
      dirtyPreferences: false,
    }) },
  [FETCH_CRUISE_CABIN_DETAILS]: (state) => ({
    ...state,
    cabinDetails: null,
    cabinDetailsLoading: false,
    cabinDetailsError: true,
  }),
})

export default createReducer<App.CruiseState>(initialState, {
  [API_CALL_REQUEST]: (state, action) => apiRequests(action.api)(state, action),
  [API_CALL_FAILURE]: (state, action) => apiFailures(action.api)(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiSuccesses(action.api)(state, action),
  [SAVE_CABIN_OPTION]: (state, action) => {
    saveCruiseCabinOptionsState(action.data)
    return {
      ...state,
      cruiseCabinPreferences: action.data,
      isCabinOptionsRestored: false,
      dirtyPreferences: true,
      cabinPricing: null,
    }
  },
  [RESTORE_CABIN_OPTION]: (state, action) => {
    return {
      ...state,
      isCabinOptionsRestored: true,
      cruiseCabinPreferences: action.data,
      dirtyPreferences: true,
      cabinPricing: null,
    }
  },
  [RESET_SESSION_ID]: (state) => ({ ...state, revelexSessionId: null }),
  [RESET_REVELEX_CALLS]: (state) => ({
    ...state,
    cabinRates: null,
    revelexSessionId: null,
    cabinPricing: null,
    cabinHold: null,
    cabinDetails: null,
    cabinAvailability: null,
    cabinRateDetails: null,
    cabinRatesError: false,
    cruiseBookingInfo: null,
    cruiseCabinPreferences: null,
    cabinHoldError: undefined,
    cabinPricingError: false,
    cabinPricingErrorToRender: undefined,
    cabinDetailsError: false,
  }),
  [RESET_CABIN_AVAILABILITY]: (state) => ({
    ...state,
    cabinAvailability: null,
    cabinAvailabilityError: false,
    cabinAvailabilityLoading: false,
  }),
  [CRUISE_SET_SEARCH_FACETS]: (state, action) => ({
    cruiseFacets: {
      ...state.cruiseFacets,
      [action.key]: {
        fetching: false,
        facets: action.data,
      },
    },
  }),
  [CRUISE_SET_CRUISE_LINES]: (state, action) => ({
    cruiseLines: action.data,
  }),
  [CRUISE_IN_FLOW_CHECKOUT_STEP]: (state, action) => ({ ...state, inFlowCheckoutStep: action.data }),
})
